import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressButtonComponent } from '@modules/components/progress-button/progress-button.component';
import { ButtonModule } from 'primeng/button';

@NgModule({
	declarations: [ProgressButtonComponent],
	imports: [CommonModule, ButtonModule],
	exports: [ProgressButtonComponent],
})
export class ProgressButtonModule {}
